module.exports = __webpack_public_path__ + "img/ug.31c566aa.svg";